import { render, staticRenderFns } from "./CallingSystem.vue?vue&type=template&id=00c1e71c&scoped=true"
import script from "./CallingSystem.vue?vue&type=script&lang=js"
export * from "./CallingSystem.vue?vue&type=script&lang=js"
import style0 from "./CallingSystem.vue?vue&type=style&index=0&id=00c1e71c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c1e71c",
  null
  
)

export default component.exports